import { Injectable } from '@angular/core';
import { Subject } from 'rxjs';

@Injectable({
  providedIn: 'root'
})
export class MenuRegenerationService {
  private menuRegenerationSubject = new Subject<void>();
  public menuRegeneration$ = this.menuRegenerationSubject.asObservable();

  constructor() { }

  // Emite un evento para regenerar el menú
  // TO DO: Debe utilizarse cuando se implemente la renovacion de user-session
  public triggerMenuRegeneration(): void {
    this.menuRegenerationSubject.next();
  }
}
